import api from 'services/api';

/**
 * `Number(null)` e `Number('')` são `0`, e aqui zero tem significado: em `id_almox` é o padrão do
 * produto, em `minimo` é o alerta silenciado. Sem esta guarda, campo ausente vira configuração —
 * a mais abrangente possível — em vez de ser descartado. Mesmo critério de `paraNumero` em
 * utils/estoqueMinimo.js.
 */
const ausente = (value) => value === null || value === undefined || value === '';

const toInt = (value) => {
  if (ausente(value)) {
    return null;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? Math.trunc(parsed) : null;
};

const toFloat = (value) => {
  if (ausente(value)) {
    return null;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const toText = (value) => {
  if (value === null || value === undefined) {
    return null;
  }

  const text = String(value).trim();
  return text === '' ? null : text;
};

export const normalizeMinimos = (payload) => {
  const rows = Array.isArray(payload?.minimos)
    ? payload.minimos
    : (Array.isArray(payload) ? payload : []);

  return rows
    .filter((row) => row && typeof row === 'object')
    .map((row) => ({
      id_produto: toInt(row.id_produto),
      id_almox: toInt(row.id_almox),
      minimo: toFloat(row.minimo),
      produto_descricao: toText(row.produto_descricao),
      almox_descricao: toText(row.almox_descricao),
    }))
    .filter((row) => row.id_produto !== null && row.id_almox !== null && row.minimo !== null);
};

class EstoqueMinimosService {
  async buscarMinimos(signal = null) {
    const config = signal ? { signal } : {};
    const response = await api.get('/estoque/minimos', config);

    return normalizeMinimos(response.data?.data ?? response.data);
  }

  /**
   * Substitui a configuração do produto inteiro.
   *
   * `null` em `padrao` ou em `excecoes[].minimo` apaga a linha; `0` grava zero. A distinção é
   * preservada de propósito — o backend depende dela para os três estados.
   */
  async salvarProduto(idProduto, { padrao, produto_descricao, excecoes = [] }) {
    const response = await api.put(`/estoque/minimos/produto/${idProduto}`, {
      padrao: padrao === undefined ? null : padrao,
      produto_descricao,
      excecoes: excecoes.map((excecao) => ({
        id_almox: excecao.id_almox,
        minimo: excecao.minimo === undefined ? null : excecao.minimo,
        ...(excecao.almox_descricao ? { almox_descricao: excecao.almox_descricao } : {}),
      })),
    });

    return normalizeMinimos(response.data?.data ?? response.data);
  }
}

const estoqueMinimosService = new EstoqueMinimosService();

export default estoqueMinimosService;
